import { render, staticRenderFns } from "./AnalyticsSupportTracker.vue?vue&type=template&id=2127baf9"
import script from "./AnalyticsSupportTracker.vue?vue&type=script&lang=js"
export * from "./AnalyticsSupportTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports